const PROVIDER_BASE_URL = {
  linkedin: 'linkedin.com/company/',
  store_links__app_store: 'apps.apple.com/br/app/',
  store_links__play_store: 'play.google.com/store/apps/details?id=',
}

export const externalLinkPlaceholders = (provider) => {
  const baseUrl = PROVIDER_BASE_URL[provider]
  if (!baseUrl) return ''
  return `https://${baseUrl}`
}

export const externalLinkPrefixValidation = (value, provider) => {
  let baseUrl = PROVIDER_BASE_URL[provider] || ''
  if (!value || value === `https://${baseUrl}` || value === `https://www.${baseUrl}`) {
    return ''
  }
  if (value.includes(`https://${baseUrl}`) || value.includes(`https://www.${baseUrl}`)) {
    return value
  } else {
    return `https://${baseUrl}${value}`
  }
}
